import useSWRImmutable from 'swr/immutable'
import { fetcher } from '@/utils/fetcher'
import { API_URL } from '@/utils/constants'
import { isCollectionObjectSlug } from '@/utils/collection-object'

const SKIP_SLUGS = ['%5Bid%5D', 'sub-100k', 'sub-1k']

function sortAttributes(data: any[]) {
	return data?.map(({ trait_type, values }) => ({
		trait_type,
		values: values?.sort((a: any, b: any) => {
			if (a.count < b.count) return -1
			if (b.count < a.count) return 1
			if (a.value > b.value) return 1
			if (b.value > a.value) return -1
			return 0
		})
	}))
}

export default function useCollectionAttributes(slug?: string) {
	const shouldFetch = slug && !SKIP_SLUGS.includes(slug) && !isCollectionObjectSlug(slug)
	const { data, error, isLoading } = useSWRImmutable(
		shouldFetch ? `${API_URL}/collection/${encodeURIComponent(slug)}/attributes` : null,
		fetcher
	)

	return {
		attributes: data ? sortAttributes(data) : [],
		isLoading,
		error
	}
}
